import React from "react";
import { autoFontColor } from "../../../../../../utils/color";

/** One picked (not yet committed) tie in the editor's pred/succ cell. */
const PickedChip: React.FC<{
  label: string;
  code: string;
  color: string;
  onRemove: () => void;
}> = ({ label, code, color, onRemove }) => (
  <span className="dep-table-ghost-pick">
    {code && (
      <span
        className="dep-table-ghost-pick-code"
        style={{
          background: color || undefined,
          color: color ? autoFontColor(color) : undefined,
        }}
      >
        {code}
      </span>
    )}
    <span className="dep-table-ghost-pick-name">{label}</span>
    <button type="button" className="dep-table-ghost-pick-x" title="Remove" onClick={onRemove}>
      ✕
    </button>
  </span>
);

export default PickedChip;
